module.exports = __webpack_public_path__ + "5a738585628c388f2bc95d3a290930c8.svg";